/* eslint-disable camelcase */
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import _isEqual from "lodash/isEqual"
import _isEmpty from "lodash/isEmpty"
import { NumericFormat } from "react-number-format"
import cx from "classnames"
import useWindowResize from "@/hooks/useWindowResize"
import {
  isPromoAllowed,
  sanitizeAndDecodeHtml,
  sanitizeInnerHtml,
} from "@/utils/helper"
import { initPriceSpider } from "@/components/ProductDetail/v3/productDetailsHelper"
import {
  addAnalyticsForSelectionDropdown,
  addDataLayerForConfigurationExapandState,
  getEventInfo,
  offerClickEventAnalytics,
  reviewClickAnalytics,
} from "@/components/ProductDetail/v3/analytics"

import Accordion from "@/components/core/Accordion/Accordion"
// import ListPrice from "@/components/ProductDetail/v3/ProductDetailView/ListPrice"
import SwatchList from "@/components/ProductDetail/v3/ProductDetailView/SwatchList"
import OptionsSelector from "@/components/ProductDetail/v3/OptionsSelector"
import InstallReqItems from "@/components/ProductDetail/v3/ProductDetailView/InstallReqItems"
import AddToCart from "@/components/ProductDetail/v3/AddToCart"
import MoreFromCollection from "@/components/ProductDetail/v3/MoreFromCollection"
import ProductAccordionList from "@/components/ProductDetail/v3/ProductAccordionList"
import CatalogCTA from "@/components/ProductDetail/v3/CatalogCTA"
import InstallService from "@/components/ProductDetail/v3/InstallService"
import ServiceAvailability from "@/components/ProductDetail/v3/ServiceAvailability"

import toolTipInfoIcon from "@/public/icons/tooltip-info.svg"
import infoIcon from "@/public/icons/warning.svg"
import assistance from "@/public/icons/assistance.svg"
import ReactStars from "react-rating-stars-component"
import HalfStar from "@/public/icons/half-star.svg"
import FullStar from "@/public/icons/full-star.svg"
import EmptyStar from "@/public/icons/empty-star.svg"
import BundleList from "@/components/Shared/BundleList"
import { formatBundleItems } from "@/utils/product"
import { isBrandTransact } from "@/utils/index"
import ProductOnDisplay from "../ProductDisplay"
import { ESTIMATED_TOTAL_FOR_NO_COST_EMI } from "@/constants"
import { selectPdpState } from "@/store/features/pdpSlice"
import Button from "@/components/core/Button/Button"
import UpsellServicesMobile from "@/components/Shared/UpsellInstallServices/UpsellServicesMobile"

const ProductDescription = forwardRef((props, ref) => {
  const { rightSectionRef, addCartContainer, notifyContainer } = ref
  const {
    config = {},
    badgeTxt = "",
    isDiscontinued = false,
    discontinuedProduct = false,
    staticTexts = {},
    name = "",
    desc = "",
    customerFacingSKU = "",
    sku = "",
    price = 0,
    isPersonaANY = false,
    ProductPriceSpiderIncluded_s = false,
    discountPercent = 0,
    discountedPrice = 0,
    currencySign = "",
    isType = "",
    persona = "",
    productInfo,
    handleSetPriceTooltip = () => {},
    options = [],
    curroptions = [],
    facetLabels = [],
    selectMoreTooltipData = "",
    selectoption = () => {},
    isRegionSoldOnline = true,
    addToCartProps = {},
    addToCartProps: { specialOrder = "", backOrder = "" } = {},
    productOnStock = 1,
    promoTitle = "",
    isProjectPack = "",
    disableEcommerce = true,
    freightPolicyType = "",
    overSizedType = "",
    excludedState = "",
    productAnalyticsData = {},
    handleQuantityChange = () => {},
    comparedProductsCount = 0,
    isColorDiscontinued = false,
    handleNavChange = () => {},
    onAddToCompare = () => {},
    onRemoveFromCompare = () => {},
    checkProductCategory = () => {},
    compare = {},
    isComboSku = false,
    productCategory = "",
    isEnable = true,
    isParts = false,
    showToaster = () => {},
    onAvailableColor = () => {},
    findStoreUrl = "",
    isFavorite = false,
    favItem = [],
    ctData = {},
    customerBrandName = "",
    replaceAddToCart = false,
    disableRatings = false,
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = false,
    fusionQueryId = "",
    docId = "",
    narrativeDescription = "",
    partReplacementSuggestions = "",
    pdpJson = {},
    promoDescription = "",
    onAddToCart = () => {},
    mboxes = [],
    presetConfigObject = {},
    productType = "",
    installationDataFromProp = [],
    designServiceDataFromProp = [],
    installationData = [],
    locale = "",
    productData = {},
    businessUnitName = "",
    discontinuedProductb = "",
    ProductRequiredAccessoriesGroupsList = [],
    superSku = "",
    designServiceData = [],
    productServices = [],
    getZipCode = () => {},
    currencyCode = "",
    isPdpPropsLoaded = false,
    isFragile = false,
    ctLoading,
    listPrice,
    installErrorCallback,
    warehouses,
    setWareHouses,
    pinCodeError,
    setPinCodeError,
    reqItemLwData = [],
    installReq = [],
    quantity,
    setQuantity,
    handleBuyNow = () => {},
    setPincode = () => {},
    setIsOutOfStock = () => {},
    isOutOfStock = false,
    installServiceData,
    setInstallServiceData,
    isChecked,
    setIsChecked,
    bundleItems,
    setBundleItems,
    reviews,
    notifyClicked = false,
    setIsEtaLoading=()=>{},
    upSellData
  } = props

  // const { isEnableBrand } = config
  const {
    InstallationCost_s,
    InstallationAvailable_s,
    productInRiverId_s,
    redirectUrl_s,
    relatedProductLink_s,
    relatedProduct_s,
  } = productData

  const dispatch = useDispatch()
  const slickRef = useRef(null)

  const [width, height] = useWindowResize()

  const [showPromo, setShowPromo] = useState(false)
  const [descShowMore, setDescShowMore] = useState(false)
  const [allowedDescCount, setAllowedDescCount] = useState(0)
  const [bundleAdditionalFeatures, setBundleAdditionalFeatures] = useState([])
  const [currentQty, setCurrentQty] = useState(1)
  const [availableQty, setAvailableQty] = useState(0)
  const [installError, setInstallError] = useState(true)
  const [installProductInfo, setInstallProductInfo] = useState({})
  const [installationError, setInstallationError] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [reqItemsError, setReqItemsError] = useState({})
  const { status = "" } = useSelector(selectPdpState)

  const [notifySuccess, setNotifySuccess] = useState(false)
  const installCost =
    InstallationCost_s !== "Not Applicable" ? InstallationCost_s : ""
  const isInstallation = InstallationAvailable_s === "Yes" ? true : false

  const installService = useCallback(() => {
    setInstallServiceData({
      isInstallation: InstallationAvailable_s === "Yes" ? true : false,
    })
  })

  const setNarrativeDescription = useCallback(() => {
    if (narrativeDescription) {
      const descCount = narrativeDescription?.length ?? 0
      const allowedCount = width > 1023 && width < 1280 ? 230 : 300
      setAllowedDescCount(allowedCount)
      setDescShowMore(descCount > allowedCount)
    }
  })

  const formatBundle = useCallback(() => {
    if (productData.bundleItems && productData.bundleItems.length) {
      formatBundleItems(productData.bundleItems, productData.BundleList_ss)
        .then(d => {
          setBundleItems(d)
        })
        .catch(ex => console.log(ex))
    }
  })
  const getBundleFeatures = () => {
    const features = []
    for (const [key, value] of Object.entries(productData)) {
      const match = key.match(/^ProductWebFeatures_(\d+)_Title_s$/)
      if (match) {
        const index = match[1]
        const title = value
        const descriptionKey = `ProductWebFeatures_${index}_Description_ss`
        const descriptions = productData[descriptionKey] || []
        features.push({ title, descriptions })
      }
    }
    setBundleAdditionalFeatures(features)
  }
  useEffect(() => {
    installService()
  }, [InstallationAvailable_s])

  useEffect(() => {
    setNarrativeDescription()
  }, [narrativeDescription, width])

  useEffect(() => {
    window.addEventListener("scroll", handleScrollRight)
    return () => {
      window.removeEventListener("scroll", handleScrollRight)
    }
  }, [])

  useEffect(() => {
    formatBundle()
    getBundleFeatures()
  }, [props.productData])

  const handleSelectoption = useCallback((value, facet, dropdownName) => {
    addAnalyticsForSelectionDropdown(value, dropdownName, productInfo)
    selectoption(value, facet)
  })

  const handleScrollRight = useCallback(() => {
    const rightSecHeight = rightSectionRef.current?.clientHeight
    if (rightSectionRef.current && width >= 1024) {
      rightSectionRef.current.style.top = `-${rightSecHeight - height}px`
    }
  })

  const onQtyChange = useCallback(qty => {
    if (qty) {
      setCurrentQty(qty)
      handleQuantityChange(qty)
    }
  })

  const initPrice = useCallback(() => {
    if (ProductPriceSpiderIncluded_s) {
      initPriceSpider()
    }
  })

  const setInstallService = useCallback(() => {
    window.PriceSpider?.rebind()
    setInstallServiceData({})
  })

  useEffect(() => {
    initPrice()
  }, [ProductPriceSpiderIncluded_s])

  useEffect(() => {
    setInstallService()
  }, [sku])

  let isBrandDiscontinued = isDiscontinued
  const isBrandOrTransact = isBrandTransact()
  if (isDiscontinued && isBrandOrTransact) {
    isBrandDiscontinued = false
  }

  const setInstallErrorCallback = useCallback(() => {
    installErrorCallback(installError)
  })

  useEffect(() => {
    setInstallErrorCallback()
  }, [installError])

  const scrollToSpendSave = useCallback(() => {
    let element = document.getElementById("spendSaveDisplayDiv")
    let headerOffset = 120
    let elementPosition = element.getBoundingClientRect().top
    let offsetPosition = elementPosition + window.scrollY - headerOffset
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
    offerClickEventAnalytics()
  })

  // const productDescriptionSpendSave =
  //   pdpJson.descriptionProductNotAvailable.split("%")[1]

  // const percentValue = productDescriptionSpendSave.substring(
  //   productDescriptionSpendSave.length - 2,
  //   productDescriptionSpendSave.length
  // )

  const triggerSaleAssist = useCallback(() => {
    const payload = { data: { code: "mountWidget" } }
    const jsonPayload = JSON.stringify(payload)
    if (window && window.postMessage) {
      window.postMessage(jsonPayload, window.location.origin)
    }
  })
  const scrollToReviews = () => {
    let element = document.getElementsByClassName("review-title")[0]
    let headerOffset = 120
    let elementPosition = element.getBoundingClientRect().top
    let offsetPosition = elementPosition + window.scrollY - headerOffset
    reviewClickAnalytics()
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }


  const seeAvailableOptionClick = () => {
    window.location.href = `${relatedProductLink_s}?skuId=${relatedProduct_s}`
  }

  return (
    <div ref={rightSectionRef} className="product-detail-page__right-sticky">
      <div className="row product-detail-page__main">
        <div className="col-12">
          {!isBrandOrTransact &&
            ((badgeTxt && !isDiscontinued) ||
              discontinuedProduct ||
              InstallationAvailable_s) && (
              <div className="product-detail-page__badge">
                {!isDiscontinued && badgeTxt !== "" && (
                  <label className="product-detail-page__badge-new">
                    {badgeTxt}
                  </label>
                )}
                {discontinuedProduct && (
                  <p className="product-detail-page__badge-discontinued">
                    {staticTexts?.discontinued}
                  </p>
                )}
                {!isDiscontinued &&
                  isInstallation &&
                  InstallationAvailable_s &&
                  discountedPrice <= ESTIMATED_TOTAL_FOR_NO_COST_EMI && (
                    <p className="product-detail-page__badge-installation-available">
                      {installCost + " " + staticTexts?.installationAvailable}
                    </p>
                  )}
                {bundleItems.length ? (
                  <p className="product-detail-page__badge-installation-available">
                    {staticTexts?.completeSolution}
                  </p>
                ) : null}
                {!isDiscontinued &&
                discountedPrice > ESTIMATED_TOTAL_FOR_NO_COST_EMI ? (
                  <p className="product-detail-page__badge-installation-available">
                    {staticTexts?.noCostEmi}
                  </p>
                ) : null}
              </div>
            )}
          {name || desc ? (
            <h1 className="product-detail-page__title-desc">
              <span className="product-detail-page__title">
                {name ? name : desc}
              </span>
              {name && desc && (
                <p className="product-detail-page__description">
                  {" "}
                  {desc.replace(/"/g, " inch")}
                </p>
              )}
            </h1>
          ) : (
            <h1 className="product-detail-page__title-desc">
              <span className="product-detail-page__title">
                <p className="shimmer-loading__para shimmer width-170"></p>
              </span>
              <p className="shimmer-loading__para shimmer width-170 product-detail-page__description"></p>
            </h1>
          )}
          {customerFacingSKU || sku ? (
            <span className="product-detail-page__sku-id">
              {bundleItems.length ? "SKU: " : null}
              {customerFacingSKU || sku}
            </span>
          ) : (
            <span className="product-detail-page__sku-id">
              <p className="shimmer-loading__para shimmer width-170"></p>
            </span>
          )}
          {reviews ? (
            <div className="review-stars">
              <>
                <ReactStars
                  count={5}
                  value={reviews.averageRating.toFixed(1)}
                  size={24}
                  edit={false}
                  isHalf={true}
                  emptyIcon={<img src={EmptyStar.src} />}
                  halfIcon={<img src={HalfStar.src} />}
                  filledIcon={<img src={FullStar.src} />}
                />
                <div className="review" onClick={scrollToReviews}>
                  {`${reviews.averageRating.toFixed(1)}  (${reviews.count})`}
                </div>
              </>
            </div>
          ) : (
            <div className="no-reviews" onClick={scrollToReviews}>
              Rate the Product
            </div>
          )}
        </div>
      </div>
      <SwatchList productData={productData} {...props} />
      {bundleItems.length ? (
        <BundleList
          items={bundleItems}
          title={`Included Items ${
            discountPercent > 0
              ? `: (${
                  isType === "absolute"
                    ? currencySign + discountPercent
                    : discountPercent + "%"
                }
        ${staticTexts?.discount} on this bundle)`
              : null
          }`}
        />
      ) : null}
      {!bundleItems.length && price > 0 && !isBrandDiscontinued ? (
        <div
          className={cx({
            "row no-gutters product-detail-page__price-main": true,
            "price-retail-exclusive": ProductPriceSpiderIncluded_s,
          })}
        >
          <div className="col-12 product-detail-page__price">
            {!isPersonaANY && (
              <div className="product-detail-page__price-value" tabIndex="0">
                <NumericFormat
                  value={discountedPrice > 0 ? discountedPrice : price}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
                <div className="product-detail-page__price-alltaxes-text">
                  {props.staticTexts.inclusiveOfAllTaxes}
                </div>
                {discountedPrice > 0 && discountedPrice !== price && (
                  <div
                    className="col-12 product-detail-page__discount"
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    <span className="product-detail-page__list-text">
                      {" "}
                      {props.staticTexts.refPrice}
                    </span>
                    <span className="product-detail-page__discount-price">
                      <NumericFormat
                        value={price}
                        displayType="text"
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </span>
                    {discountPercent > 0 && (
                      <span className="product-detail-page__percent-off">
                        {isType === "absolute"
                          ? currencySign + discountPercent
                          : discountPercent + "%"}{" "}
                        {staticTexts?.percentOff}
                      </span>
                    )}
                  </div>
                )}
                {/* {isPromoAllowed() ? ( */}
                {/*<span
                  className="product-detail-page__price-extradiscount-text"
                  onClick={scrollToSpendSave}
                >
                  {staticTexts.spendSaveDescription}
                </span> */}
                {/* ) : (
                  <span
                    className="product-detail-page__price-extradiscount-text gbh-data-layer"
                    onClick={() =>
                      dispatch(setAuthModalVisibility({ show: true }))
                    }
                    data-gbh-data-layer='{"eventName":"pdp:product details:sign in","eventAction":"pdp:product details:sign in","internalLinkName":"login to get extra off","internalLinkType":"pdp:sign in","internalLinkZoneName":"pdp:product details","clickInternalLinks":"true","eventType":"navigation","internalLinkURL":"n/a","internalLinkPosition":"pdp","eventMsg":"n/a","eventStatus":"n/a"}'
                  >
                    Login to get extra {percentValue}% off
                  </span>
                )} */}
              </div>
            )}
            {price && (persona === "FF" || persona === "KEMP") && (
              <div className="product-detail-page__customer-group">
                {persona === "FF" && (
                  <span>{staticTexts?.friendsFamilyPrice}</span>
                )}
                {persona === "KEMP" && (
                  <span>{staticTexts?.associatePrice}</span>
                )}
              </div>
            )}
          </div>

          {/* {price && !ProductPriceSpiderIncluded_s && !isBrandDiscontinued && (
            <div className="product-detail-page__list-price--associate">
              <ListPrice {...props} />
            </div>
          )} */}
        </div>
      ) : null}
      {!isDiscontinued && Object.keys(options).length > 0 ? (
        <div className="row no-gutters">
          <OptionsSelector
            i18n={staticTexts}
            data={options}
            curroptions={curroptions}
            selectoption={handleSelectoption}
            facetLabels={facetLabels}
            tooltipdata={selectMoreTooltipData}
            selectMoreTooltipHandler={handleSetPriceTooltip}
            configurationAccordianDataLayer={(title, accordianState) =>
              addDataLayerForConfigurationExapandState(
                title,
                accordianState,
                productInfo
              )
            }
          />
        </div>
      ) : null}
      {!isBrandOrTransact ? (
        <InstallReqItems {...props} reqItemsError={reqItemsError} />
      ) : null}
      {isRegionSoldOnline && specialOrder === "Yes" && (
        <div className="product-detail-page__discontinued-txt product-detail-page__order-messaging">
          {staticTexts?.specialOrder}
        </div>
      )}
      {ProductPriceSpiderIncluded_s && (
        <div className="product-detail-page__price-spider-section">
          <p className="product-detail-page__price_spider_title">
            {staticTexts?.priceSpiderTitle}
          </p>
          <div className="ps-widget" ps-sku={sku}></div>
        </div>
      )}
      {promoTitle &&
        !ProductPriceSpiderIncluded_s &&
        isRegionSoldOnline &&
        !isDiscontinued &&
        !isProjectPack &&
        (backOrder === "Yes" || productOnStock > 0) && (
          <div className="product-detail-page__promo-section">
            <Accordion
              isOpen={false}
              title={promoTitle}
              handleOpen={() => setShowPromo(true)}
              handleClose={() => setShowPromo(false)}
              isArrow={true}
            >
              {showPromo && promoDescription && (
                <p className="product-detail-page__promo-desc">
                  {sanitizeInnerHtml(promoDescription)}
                </p>
              )}
            </Accordion>
          </div>
        )}
      {!disableEcommerce &&
        !ProductPriceSpiderIncluded_s &&
        isRegionSoldOnline &&
        !isDiscontinued &&
        !isProjectPack &&
        productOnStock > 0 &&
        (_isEqual(freightPolicyType, overSizedType) ||
          !_isEmpty(excludedState)) && (
          <div className="row no-gutters product-detail-page__oversized-msg-section">
            <div className="col-12 oversized-msg-tooltip">
              {_isEqual(freightPolicyType, overSizedType) && (
                <span className="oversized-msg-primary-txt">
                  <img
                    className="oversized-msg-info-icon"
                    src={toolTipInfoIcon.src}
                    alt={staticTexts?.toolTip}
                  />
                  <span>
                    {sanitizeInnerHtml(staticTexts?.primaryTxt)}{" "}
                    {sanitizeInnerHtml(staticTexts?.secondaryTxt)}
                  </span>
                </span>
              )}

              {!_isEmpty(excludedState) && (
                <span className="oversized-msg-primary-txt">
                  <img
                    className="oversized-msg-info-icon"
                    src={toolTipInfoIcon.src}
                    alt={staticTexts?.toolTip}
                  />
                  <span>
                    {sanitizeInnerHtml(
                      `${staticTexts?.shippingTitle} ${staticTexts?.shippingDescription} ${excludedState}.`
                    )}
                  </span>
                </span>
              )}
            </div>
          </div>
        )}
      {isProjectPack && (
        <div className="row no-gutters">
          <div className="col-12 product-detail-page__info-mssg">
            <p>{sanitizeAndDecodeHtml(staticTexts?.projectPackMssg)}</p>
          </div>
        </div>
      )}
      {isBrandOrTransact ? (
        <CatalogCTA
          sku={sku}
          config={config}
          productName={name}
          staticTexts={staticTexts}
          redirectUrl={redirectUrl_s}
          inriverId={productInRiverId_s}
          isDiscontinued={isDiscontinued}
          isSoldOnline={isRegionSoldOnline}
        />
      ) : (
        <>
          {isRegionSoldOnline &&
          (Boolean(bundleItems.length) || productOnStock > 0) ? (
            <div className="row no-gutters">
              <InstallService
                sku={sku}
                qty={currentQty}
                i18n={staticTexts}
                isError={installError}
                masterSku={productInRiverId_s}
                disableCart={setInstallError}
                setWareHouses={setWareHouses}
                setAvailableQty={setAvailableQty}
                installServiceData={installServiceData}
                setInstallationData={setInstallServiceData}
                isInstallationAvailable={InstallationAvailable_s}
                isBundle={Boolean(bundleItems.length)}
                productInfo={productInfo}
                setInstallProductInfo={setInstallProductInfo}
                installErrorCallback={installErrorCallback}
                pinCodeError={pinCodeError}
                setPinCodeError={setPinCodeError}
                installationError={installationError}
                setInstallationError={setInstallationError}
                error={error}
                setError={setError}
                loading={loading}
                setLoading={setLoading}
                installReq={installReq}
                setReqItemsError={setReqItemsError}
                setPincodeValue={setPincode}
                setNotifySuccess={setNotifySuccess}
                setIsOutOfStock={setIsOutOfStock}
                isOutOfStock={isOutOfStock}
                setIsEtaLoading={setIsEtaLoading}
              />
            </div>
          ) : null}
          {installServiceData?.isInstallation && installServiceData?.name ? (
            <ServiceAvailability
              config={config}
              i18n={staticTexts}
              isChecked={isChecked}
              currencySign={currencySign}
              setIsChecked={setIsChecked}
              installationData={installServiceData}
            />
          ) : null}
          {bundleItems.length ? (
            <ul className="bundle-price__wrap">
              <li className="bundle-price__item">
                <span>{`${staticTexts?.subTotal} (${bundleItems.length} ${staticTexts?.items})`}</span>
                <span>
                  MRP{" "}
                  <NumericFormat
                    className={`bundle-price__subtotal ${
                      listPrice > (discountedPrice ? discountedPrice : price)
                        ? "discounted"
                        : ""
                    }`}
                    value={listPrice}
                    displayType="text"
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandsGroupStyle={"lakh"}
                  />
                </span>
              </li>
              {discountedPrice !== price && (
                <li className="bundle-price__item">
                  <span>
                    {isType === "absolute"
                      ? currencySign + discountPercent
                      : discountPercent + "%"}{" "}
                    {staticTexts?.discount}
                  </span>
                  <NumericFormat
                    value={discountedPrice - price}
                    displayType="text"
                    thousandSeparator={true}
                    prefix={currencySign}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandsGroupStyle={"lakh"}
                  />
                </li>
              )}
              <li className="bundle-price__item bundle-price__total">
                <span>{staticTexts?.total}</span>
                <NumericFormat
                  value={discountedPrice ? discountedPrice : price}
                  displayType="text"
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  thousandsGroupStyle={"lakh"}
                />
              </li>
              <div className="product-detail-page__price-alltaxes-text-bundle">
                {props.staticTexts.inclusiveOfAllTaxes}
              </div>
            </ul>
          ) : null}
          {!ctLoading && status === "succeeded" && (
            <AddToCart
              ref={addCartContainer}
              setIsOutOfStock={setIsOutOfStock}
              isOutOfStock={isOutOfStock}
              notifyContainer={notifyContainer}
              {...addToCartProps}
              staticTexts={staticTexts}
              onQtyChange={onQtyChange}
              onAddToCart={cartItemProduct => onAddToCart(cartItemProduct)}
              onAdd={() => onAddToCompare()}
              onRemove={() => onRemoveFromCompare()}
              checkCategory={() => checkProductCategory()}
              comparedProductsCount={comparedProductsCount}
              compareData={compare}
              sku={sku}
              isComboSku={isComboSku}
              productCategory={productCategory}
              isEnable={isEnable}
              isParts={isParts}
              productOnStock={productOnStock}
              isColorDiscontinued={isColorDiscontinued}
              isDiscontinued={isDiscontinued}
              specialOrder={specialOrder}
              backOrder={backOrder}
              ProductPriceSpiderIncluded_s={ProductPriceSpiderIncluded_s}
              showToaster={showToaster}
              onAvailableColor={() => onAvailableColor()}
              productData={productAnalyticsData}
              findStoreUrl={findStoreUrl}
              isFavorite={isFavorite}
              favItem={favItem}
              price={price}
              ctData={ctData}
              isRegionSoldOnline={isRegionSoldOnline}
              customerBrandName={customerBrandName}
              handleNavChange={navActive => handleNavChange(navActive)}
              replaceAddToCart={replaceAddToCart}
              disableRatings={disableRatings}
              replaceAddToCartCtaLink={replaceAddToCartCtaLink}
              replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
              linkNewTab={linkNewTab}
              disableEcommerce={disableEcommerce}
              fusionQueryId={fusionQueryId}
              docId={docId}
              analyticData={productAnalyticsData?.stringProductInfo}
              isPdpPropsLoaded={isPdpPropsLoaded}
              installError={installError}
              masterSku={productInRiverId_s}
              availableQty={availableQty}
              installationData={installServiceData}
              isInstallationAdded={isChecked}
              isFragile={isFragile}
              warehouses={warehouses}
              isBundle={Boolean(bundleItems.length)}
              productInfo={productInfo}
              installProductInfo={installProductInfo}
              pinCodeError={pinCodeError}
              setPinCodeError={setPinCodeError}
              installationError={installationError}
              setInstallationError={setInstallationError}
              error={error}
              setError={setError}
              loading={loading}
              setLoading={setLoading}
              reqItemsError={!!Object.keys(reqItemsError).length}
              quantity={quantity}
              setQuantity={setQuantity}
              handleBuyNow={handleBuyNow}
              notifySuccess={notifySuccess}
              setPincode={setPincode}
              setNotifySuccess={setNotifySuccess}
              productAnalyticsData={productAnalyticsData}
              productInRiverId_s={productInRiverId_s}
              name={name}
              desc={desc}
              notifyClicked={notifyClicked}
            />
          )}
        </>
      )}
      {isDiscontinued && (
        <>
          <div className="product-detail-page__discontinued">
            <img alt="" src={infoIcon.src} />
            <span className="product-detail-page__discontinuedText">
              {staticTexts?.brandsDiscontinuedMsg}
            </span>
          </div>
          <div className="product-detail-page__available-color-section">
            <Button
              role="button"
              className="product-detail-page__available-option-btn"
              onClick={seeAvailableOptionClick}
              flexible={true}
              label={"See Available Option"}
              size="large"
              type="primary"
            />
          </div>
        </>
      )}
      <div className="saleassist-trigger-parent-div">
        <img
          src={assistance.src}
          alt="Phone"
          className="saleassist-trigger-image"
        />
        <span className="saleassist-trigger-div">
          <div>Need Assistance?</div>
          <button
            className="saleassist-trigger gbh-data-layer"
            onClick={() => triggerSaleAssist()}
            data-gbh-data-layer='{"eventName":"pdp:product details:need assistance","eventAction":"pdp:product details:need assistance","internalLinkName":"need assistance","internalLinkType":"pdp:need assistance","internalLinkZoneName":"pdp:need assistance","clickInternalLinks":"true","eventType":"navigation","internalLinkURL":"n/a","internalLinkPosition":"pdp","eventMsg":"n/a","eventStatus":"n/a"}'
          >
            <span>Chat now or schedule a meeting</span>
          </button>
        </span>
      </div>
      {narrativeDescription && (
        <div className="product-detail-page__narrative-description">
          <p
            className={`product-detail-page__narrative-description${
              descShowMore ? "--show-more" : "--none"
            }`}
          >
            {descShowMore
              ? narrativeDescription
                  .replace(/"/g, " inch")
                  .slice(0, allowedDescCount)
              : narrativeDescription.replace(/"/g, " inch")}
            {descShowMore && (
              <span>
                ...
                <a
                  className="product-detail-page__narrative-description--show-more-button gbh-data-layer"
                  onClick={() => setDescShowMore(false)}
                  data-gbh-data-layer={getEventInfo(
                    staticTexts.descReadMore.toLowerCase()
                  )}
                  data-gbh-data-layer-custom={
                    productAnalyticsData?.stringProductInfo
                  }
                >
                  {staticTexts?.descReadMore}
                </a>
              </span>
            )}
          </p>
        </div>
      )}
      {upSellData.length>0 &&
      <div>
        <UpsellServicesMobile
              upSellData={upSellData}
              slickRef={slickRef}
              currency={currencySign}
            />
      </div>}
      {discontinuedProduct && isParts && partReplacementSuggestions && (
        <MoreFromCollection
          pdpJson={pdpJson}
          sku={sku}
          i18n={{
            title: staticTexts?.moreCollection,
            discontinuedTitle: staticTexts?.moreCollectionDiscontinued,
            partNumber: staticTexts?.partNumber,
            partName: staticTexts?.partName,
          }}
          isColorDiscontinued={isColorDiscontinued}
          mboxes={mboxes}
          presetConfigObject={presetConfigObject}
          productType={productType}
          partReplacementSuggestions={partReplacementSuggestions}
        />
      )}
      <ProductAccordionList
        productData={productData}
        productInfo={productAnalyticsData.stringProductInfo}
        productSku={sku}
        config={config}
        isDiscontinued={isDiscontinued}
        staticTexts={staticTexts}
        accordionList={pdpJson?.accordianLabels}
        installationSupportLinks={pdpJson?.installationSupportLinks}
        installationDataFromProp={installationDataFromProp}
        designServiceDataFromProp={designServiceDataFromProp}
        businessUnitName={businessUnitName}
        ProductPriceSpiderIncluded_s={ProductPriceSpiderIncluded_s}
        discontinuedProductb={discontinuedProductb}
        ProductRequiredAccessoriesGroupsList={
          ProductRequiredAccessoriesGroupsList
        }
        superSku={superSku}
        currencySign={currencySign}
        productCategory={productCategory}
        designServiceData={designServiceData}
        productServices={productServices}
        productType={productType}
        getZipCode={getZipCode}
        installationData={installationData}
        persona={persona}
        currencyCode={currencyCode}
        locale={locale}
        width={width}
        replaceAddToCart={replaceAddToCart}
        disableRatings={disableRatings}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink}
        replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
        linkNewTab={linkNewTab}
        disableEcommerce={disableEcommerce}
        isProjectPack={isProjectPack}
        bundleItems={bundleItems}
        bundleAdditionalFeatures={bundleAdditionalFeatures}
      />
      <ProductOnDisplay
        pdpJson={pdpJson}
        productServices={productServices}
        installationData={installationData}
        staticTexts={staticTexts}
        currencyCode={currencyCode}
        currencySign={currencySign}
        // brandName={brandName}
        getZipCode={getZipCode}
        // findStores={findStores}
        // colorsData={colorsData}
        // shortendPagePath={shortendPagePath}
        // findStoreDetailsUrl={storeDetailsServletPath}
        productType={productType}
        productInfo={productInfo}
      />
    </div>
  )
})

ProductDescription.displayName = "ProductDescription"

export default React.memo(ProductDescription)
